/* AI Veterinar Micko — chat logika.
   Modal koristi Dawn <modal-dialog> (assets/global.js) — ESC/backdrop/focus vec rese.
   Okidaci: elementi sa klasom .js-ai-vet-open (drawer + desktop meni). */
(function () {
  'use strict';

  var DAILY_LIMIT = 5; // anonimni; ulogovani sa tokenom dobijaju 10 (limit cuva worker)
  var DAILY_LIMIT_AUTH = 10;
  var HISTORY_KEY = 'aiVetHistory';
  var QUOTA_KEY = 'aiVetQuota';
  var TOKEN_KEY = 'aiVetTok';
  var WELCOME =
    'Mjau! Ja sam Veterinar Micko. Pitaj me bilo šta o svom ljubimcu: ishrana, nega, ponašanje, oprema… Rado ću preporučiti i nešto iz naše radnje!';

  // Prevodi iz JSON bloba #ai-vet-i18n (snippets/ai-vet.liquid);
  // fallback je postojeci srpski literal, pa nista ne puca kad blob fali.
  var I18N = null;
  function t(key, fallback) {
    if (I18N === null) {
      I18N = {};
      try {
        var el = document.getElementById('ai-vet-i18n');
        if (el) I18N = JSON.parse(el.textContent) || {};
      } catch (e) {
        I18N = {};
      }
    }
    var value = I18N[key];
    return typeof value === 'string' && value ? value : fallback;
  }

  function esc(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // [Naziv](/products/handle) -> link, **bold** -> strong, novi red -> <br>;
  // ostatak vec HTML-eskejpovan
  function renderMarkdown(text) {
    return esc(text)
      .replace(
        /\[([^\]]{1,120})\]\((\/products\/[a-zA-Z0-9\-_%.]+)\)/g,
        '<a class="ai-vet-product-link" href="$2">$1</a>'
      )
      .replace(/\*\*([^*\n]{1,200})\*\*/g, '<strong>$1</strong>')
      .replace(/^\s*\*\s+/gm, '• ')
      .replace(/\n/g, '<br>');
  }

  function todayKey() {
    return new Date().toLocaleDateString('sv-SE');
  }

  function readQuota(limit) {
    try {
      var q = JSON.parse(localStorage.getItem(QUOTA_KEY) || 'null');
      if (q && q.date === todayKey() && q.limit === limit) return q.remaining;
    } catch (e) {
      /* ignorisi */
    }
    return limit;
  }

  function writeQuota(remaining, limit) {
    try {
      localStorage.setItem(QUOTA_KEY, JSON.stringify({ date: todayKey(), remaining: remaining, limit: limit }));
    } catch (e) {
      /* ignorisi */
    }
  }

  function init() {
    var modal = document.getElementById('AiVet-Modal');
    if (!modal) return;

    var workerUrl = (modal.dataset.workerUrl || '').replace(/\/+$/, '') + '/chat';
    var messagesEl = document.getElementById('AiVetMessages');
    var form = document.getElementById('AiVetForm');
    var input = document.getElementById('AiVetInput');
    var quotaEl = document.getElementById('AiVetQuota');
    var sendBtn = form.querySelector('.ai-vet-send');

    var history = [];
    try {
      history = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || '[]');
    } catch (e) {
      /* ignorisi */
    }
    var loggedIn = Boolean(modal.dataset.customerId);
    var LIMIT = loggedIn ? DAILY_LIMIT_AUTH : DAILY_LIMIT;
    var remaining = readQuota(LIMIT);
    var busy = false;

    // Ulogovan kupac: potpisani token sa App Proxy-ja (vazi 12h) dokazuje
    // workeru da je prijavljen -> 10 pitanja dnevno vezanih za nalog.
    function getAuthToken() {
      if (!loggedIn) return Promise.resolve(null);
      try {
        var t = JSON.parse(sessionStorage.getItem(TOKEN_KEY) || 'null');
        if (t && t.token && t.exp > Date.now() / 1000 + 60) return Promise.resolve(t.token);
      } catch (e) {
        /* ignorisi */
      }
      var proxy = (modal.dataset.vetProxy || '/apps/pasos').replace(/\/+$/, '');
      return fetch(proxy + '/vet-token', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (d) {
          if (d && d.token) {
            try {
              sessionStorage.setItem(TOKEN_KEY, JSON.stringify(d));
            } catch (e) {
              /* ignorisi */
            }
            return d.token;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }

    // Pasoš ljubimca (ulogovan kupac): podaci za "Pogledaj pasoš" dugme,
    // bez slika — salje se workeru koji cuva nedeljni limit
    var pasosRow = document.getElementById('AiVetPasosRow');
    var pasosBtn = document.getElementById('AiVetPasosBtn');
    var pasosData = null;
    try {
      var pasosRaw = document.querySelector('[data-ai-vet-pasos]');
      if (pasosRaw) {
        pasosData = JSON.parse(pasosRaw.textContent);
        if (Array.isArray(pasosData)) {
          pasosData = pasosData.map(function (pet) {
            var copy = {};
            for (var k in pet) {
              if (k !== 'slika') copy[k] = pet[k];
            }
            return copy;
          });
        } else {
          pasosData = null;
        }
      }
    } catch (e) {
      pasosData = null;
    }

    function persist() {
      try {
        sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(-12)));
      } catch (e) {
        /* ignorisi */
      }
    }

    function moneyRsd(cents) {
      var activeCurrency = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (activeCurrency && activeCurrency !== 'RSD') {
        return new Intl.NumberFormat(document.documentElement.lang === 'sl' ? 'sl-SI' : 'sr-RS', {
          style: 'currency',
          currency: activeCurrency,
        }).format(cents / 100);
      }
      return Math.round(cents / 100).toLocaleString('sr-RS') + ' RSD';
    }

    function imgUrl(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function addToCart(btn, variantId) {
      btn.disabled = true;
      btn.textContent = '…';
      var cartDrawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: variantId, quantity: 1 }] };
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        body.sections = cartDrawer.getSectionsToRender().map(function (s) {
          return s.id;
        });
        body.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          if (d.status) {
            // npr. rasprodato / greska
            btn.textContent = '+';
            btn.disabled = false;
            return;
          }
          btn.textContent = '✓';
          btn.classList.add('is-added');
          setTimeout(function () {
            modal.hide();
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(d);
            }
            btn.textContent = '+';
            btn.disabled = false;
            btn.classList.remove('is-added');
          }, 550);
        })
        .catch(function () {
          btn.textContent = '+';
          btn.disabled = false;
        });
    }

    // Mini kartice proizvoda ispod Mickove poruke (slika + naziv + cena + "+" u korpu)
    function attachCards(bubbleEl) {
      var links = bubbleEl.querySelectorAll('.ai-vet-product-link');
      if (!links.length) return;
      var handles = [];
      links.forEach(function (a) {
        var h = (a.getAttribute('href') || '').split('/products/')[1];
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
      handles.slice(0, 2).forEach(function (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('nema');
            return r.json();
          })
          .then(function (p) {
            var variants = p.variants || [];
            var v = variants.filter(function (x) { return x.available; })[0];
            if (!v) return; // rasprodato — bez kartice
            var card = document.createElement('div');
            card.className = 'ai-vet-card';
            card.innerHTML =
              '<a class="ai-vet-card__link" href="/products/' + handle + '">' +
              (p.featured_image
                ? '<img class="ai-vet-card__img" src="' + imgUrl(p.featured_image, 120) + '" alt="" loading="lazy">'
                : '') +
              '<span class="ai-vet-card__info">' +
              '<span class="ai-vet-card__title">' + esc(p.title) + '</span>' +
              '<span class="ai-vet-card__price">' + moneyRsd(v.price) + '</span>' +
              '</span></a>' +
              '<button type="button" class="ai-vet-card__add" aria-label="' +
              esc(t('add_to_cart', 'Dodaj u korpu')) +
              '">+</button>';
            card.querySelector('.ai-vet-card__add').addEventListener('click', function () {
              addToCart(this, v.id);
            });
            bubbleEl.appendChild(card);
            messagesEl.scrollTop = messagesEl.scrollHeight;
          })
          .catch(function () {
            /* bez kartice, link ostaje */
          });
      });
    }

    function addBubble(role, text) {
      var el = document.createElement('div');
      el.className = 'ai-vet-msg ai-vet-msg--' + (role === 'user' ? 'user' : 'bot');
      el.innerHTML = role === 'user' ? esc(text) : renderMarkdown(text);
      messagesEl.appendChild(el);
      if (role !== 'user') attachCards(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return el;
    }

    function addTyping() {
      var el = document.createElement('div');
      el.className = 'ai-vet-msg ai-vet-msg--bot ai-vet-typing';
      el.innerHTML = '<span></span><span></span><span></span>';
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return el;
    }

    function updateQuota() {
      if (remaining <= 0) {
        quotaEl.textContent =
          t('resting', 'Micko se odmara, novih {{ limit }} pitanja sutra!').replace('{{ limit }}', LIMIT) +
          (loggedIn ? '' : t('account_hint', ' Uz nalog imaš 10 dnevno.'));
        input.disabled = true;
        sendBtn.disabled = true;
        input.placeholder = t('see_tomorrow', 'Vidimo se sutra!');
      } else {
        // pluralizacija: 1 -> left_one, 2-4 -> left_few, ostalo -> left_many
        var leftKey = remaining === 1 ? 'left_one' : remaining >= 2 && remaining <= 4 ? 'left_few' : 'left_many';
        var leftFallback = remaining === 1 ? 'Još {{ n }} pitanje danas' : 'Još {{ n }} pitanja danas';
        quotaEl.textContent =
          t(leftKey, leftFallback).replace('{{ n }}', remaining) +
          (loggedIn ? '' : t('left_account_hint', ' (uz nalog 10)'));
        input.disabled = false;
        sendBtn.disabled = false;
      }
    }

    function renderHistory() {
      messagesEl.innerHTML = '';
      addBubble('bot', t('welcome', WELCOME));
      history.forEach(function (m) {
        addBubble(m.role, m.content);
      });
    }

    function send(presetText, pasos) {
      var text = presetText || input.value.trim();
      if (!text || busy || remaining <= 0) return;
      busy = true;
      input.value = '';
      history.push({ role: 'user', content: text });
      addBubble('user', text);
      persist();
      var typing = addTyping();

      var payload = { messages: history.slice(-8), locale: document.documentElement.lang };
      if (pasos) {
        payload.pasos = pasos;
        payload.customer_id = modal.dataset.customerId || '';
      }

      getAuthToken()
        .then(function (token) {
          if (token) payload.auth_token = token;
          return fetch(workerUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            return { status: res.status, data: data };
          });
        })
        .then(function (r) {
          typing.remove();
          // server je izvor istine za dnevni limit (5 anonimno / 10 uz nalog)
          if (r.data && typeof r.data.limit === 'number') LIMIT = r.data.limit;
          if (r.status === 429 || (r.data && r.data.error === 'limit')) {
            remaining = 0;
            writeQuota(0, LIMIT);
            addBubble(
              'bot',
              t('limit_reached', 'Mjau, za danas sam odgovorio na svih {{ limit }} pitanja! Vrati se sutra, odmaram šape.').replace(
                '{{ limit }}',
                LIMIT
              )
            );
          } else if (r.data && r.data.error === 'pasos_limit') {
            history.pop();
            persist();
            addBubble(
              'bot',
              t(
                'passport_weekly',
                'Pasoš tvog ljubimca pregledam jednom nedeljno, a ove nedelje smo to već uradili. Slobodno me pitaj bilo šta drugo!'
              )
            );
          } else if (r.data && r.data.reply) {
            history.push({ role: 'assistant', content: r.data.reply });
            persist();
            addBubble('bot', r.data.reply);
            if (typeof r.data.remaining === 'number') {
              remaining = r.data.remaining;
              writeQuota(remaining, LIMIT);
            }
            if (r.data.pasos_used && pasosRow) {
              pasosRow.hidden = true;
            }
          } else {
            history.pop();
            persist();
            addBubble('bot', t('err_generic', 'Uh, nešto mi je zapelo u brkovima… Probaj ponovo za koji trenutak.'));
          }
          updateQuota();
          busy = false;
        })
        .catch(function () {
          typing.remove();
          history.pop();
          persist();
          addBubble('bot', t('err_network', 'Ne mogu trenutno da se povežem… Proveri internet pa probaj ponovo.'));
          busy = false;
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      send();
    });

    if (pasosBtn && pasosData) {
      pasosBtn.addEventListener('click', function () {
        send(t('passport_prompt', 'Pogledaj pasoš mojih ljubimaca i daj mi personalizovan pregled i savete.'), pasosData);
      });
    } else if (pasosRow) {
      pasosRow.hidden = true;
    }

    document.querySelectorAll('.js-ai-vet-open').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // zatvori mobilni drawer ako je otvoren
        var drawerDetails = document.getElementById('Details-menu-drawer-container');
        if (drawerDetails && drawerDetails.hasAttribute('open')) {
          var headerDrawer = document.querySelector('header-drawer');
          if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function') {
            headerDrawer.closeMenuDrawer(e);
          } else {
            drawerDetails.removeAttribute('open');
          }
        }
        modal.show(trigger);
        renderHistory();
        updateQuota();
        // unapred namesteno pitanje (npr. dugme na stranici rase)
        var preset = trigger.getAttribute('data-ai-vet-preset');
        if (preset && remaining > 0) {
          input.value = preset;
          input.focus();
        } else if (remaining > 0 && window.matchMedia('(min-width: 750px)').matches) {
          input.focus();
        }
        messagesEl.scrollTop = messagesEl.scrollHeight;
      });
    });

    renderHistory();
    updateQuota();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
